export enum GroupType {
  ACL = 1,
  Security = 2,
  SM = 3,
  Workflow = 4,
  InvestigativeSite = 5,
  Contact = 6,
  Sponsor = 7,
  InvestigativeSiteInDataRoom = 8,
  StudyStartupTeam = 9,
  ISReaders = 10,
  StartupSpecialists = 11,
  SsuApprovers = 12,
  ISEditors = 13,
  CountryReaders = 14,
  CountryEditors = 15,
  SSUBasicSecurity = 16,
  Auditor = 17,
  AuditManager = 18,
  AuditResponse = 19,
  UserLookup = 22,
  IndexManager = 23,
  MobileAccess = 24,
  AdministrativeWorkflow = 28,
  ISProtectedDocs = 29,
  QueryManager = 30,
  GeneralQueryResponder = 31,
  ActionGroup = 32,
  ISOthers = 33,
  ISCRA = 34,
  StudyStartupTeamRoom = 35,
  SiteStartUpGroup = 36,
  TIAnalyticsGroup = 38,
  OrganizationManagement = 42,

  // the following group types are virtual and only used on UI
  ISSystemGroups = -10001,
}
